import lightbox from 'lightbox2'
export default {
  init() {
    // JavaScript to be fired on the single accommodation page
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
    })

    const options = {
      read_more: ['Read More', 'Read Less'],
      display_more: ['Display More', 'Display Less'],
      more_images: ['Load More Images', 'Display Less Images'],
      more_places: ['Load More Places To Go', 'Load Less Places To Go'],
      more_tours: ['View More Tours & Safaris', 'View Less Tours & Safaris'],
      more_accom: ['Load More Accommodation', 'Load Less Accommodation'],
      more_exp: ['Load More Experiences', 'Load Less Experiences'],
      more_articles: ['Load More Articles', 'Load Less Articles'],
    }

    Object.keys(options).forEach(function(item) {
      $('.' + item).readmore({
        speed: 1000,
        collapsedHeight: 380,
        heightMargin: 30,
        moreLink: '<span class="btn btn-secondary read-more-btn">' + options[item][0] + '</span>',
        lessLink: '<span class="btn btn-secondary read-more-btn">' + options[item][1] + '</span>',
      })
    })

    function wtv_nav_slider_trigger() {
      $('.wtv-slider-active .wtv-gallery').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: false,
      })
    }

    jQuery(document).ready(function(){

      wtv_nav_slider_trigger();

      if(jQuery('.wtv-link').length) {

        jQuery('.wtv-link').click(function(e){
          e.preventDefault();

          jQuery('.nav-item.active').removeClass('active');
          jQuery(this).parent().addClass('active');

          jQuery('.wtv-link').each(function(){
            var s = jQuery(this).attr('href');
            jQuery(s).removeClass('wtv-slider-active');
            jQuery(s).addClass('wtv-slider-inactive');
          });

          var target = jQuery(this).attr('href');
          jQuery(target).addClass('wtv-slider-active');
          jQuery(target).removeClass('wtv-slider-inactive');

          wtv_nav_slider_trigger();

        })

      }

    })


  },
}



// WEBPACK FOOTER //
// ./scripts/routes/archive.js